export default __webpack_public_path__ + "static/media/box-integrated-libraries.7941bd1c.png";